module.exports = __webpack_public_path__ + "img/album17_06.e4461475.jpg";